<template>
    <div class="container-center">


        <el-tabs v-model="segmentActive" type="border-card" @tab-click="tabClick" class="tabs-margin" v-loading="tabLoading">
            <el-tab-pane :name="'tab01'">
                <span slot="label">招投标类</span>
                <div class="todo-list-box">
                    <div class="no-data-tip" v-if="todoList.length == 0"></div>
                    <div v-else class="todo-list" v-for="(li,index) in todoList" :key="index">
                        <router-link v-if="li.messageType!='300'" class="status" :to="{name:'InviteMngInfo',params:{ fid:li.inviteProjectId }}" >{{ li.execFlag!=1?li.msgTypeName:'已办' }}</router-link>
                        <el-button class="status" v-if="li.messageType == '300'"  @click="handleDialogOpen(li.businessId)">{{ li.execFlag!=1?li.msgTypeName:'已办' }}</el-button>
                        <el-dialog title="合同交底" :visible.sync="confirmDialog" center width="700px" @close="handleDialogClose" :close-on-click-modal="false" :close-on-press-escape="false">
                            <!-- 付款比率+浮动金额 -->
                            <div>
                                <div class="title-div">合同名称：{{dhsConDisclosure.conName}}</div>
                            </div>
                            <div>
                                <div class="title-div">交底内容：{{dhsConDisclosure.content}}</div>
                            </div>
                            <div>
                                <div class="file-list">
                                    <span>附件：</span>
                                    <div>
                                        <div v-for="(file,index) in dhsConDisclosure.baseFiles" :key="index">
                                            <a :href="downloadApi +'?fileId=' + file.id" target="_blank">{{file.fileOldName || file.fileName}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!confirmAccShow">
                                <div class="title-div">状态：确认收到</div>
                            </div>
                            <div v-if="!confirmAccShow">
                                <div class="title-div">时间：{{dhsConDisclosure.conFirDate}}</div>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button v-if="confirmAccShow" type="primary" size="small" @click="confirmAcc(dhsConDisclosure.fId)">确认收到</el-button>
                                <el-button type="default" size="small" @click="handleDialogClose">关闭</el-button>
                            </div>
                        </el-dialog>
                        <p class="title" >{{ li.content }}</p>
                        <p class="date" v-if="li.messageType!='300'"><span class="icon-date"></span>截止日期：{{ li.endTime && li.endTime.substring(0,10) }}</p>
                        <p class="date" v-if="li.messageType=='300'"><span class="icon-date"></span>发送日期：{{ li.sendTime && li.sendTime.substring(0,10) }}</p>
                    </div>
                </div>
                <div class="block">
                    <el-pagination
                        @current-change="(val)=>{handleCurrentChange(val,'pager')}"
                        :page-size="pager.pageSize"
                        :current-page="pager.pageNum"
                        :total="pager.total"
                        prev-text="上一页"
                        next-text="下一页"
                        layout="total, prev, pager, next"
                        background>
                    </el-pagination>
                </div>
            </el-tab-pane>

            <el-tab-pane :name="'tab02'">
                <span slot="label">工程管理类</span>
                <div class="todo-list-box">
                    <div class="no-data-tip" v-if="todoList2.length == 0"></div>
                    <div v-else class="todo-list" v-for="(li,index) in todoList2" :key="index">
                        <!--<router-link v-if="li.execFlag!=1" class="status" :to="{name:'InviteMngInfo',params:{ fid:li.inviteProjectId }}" >{{ li.msgTypeName }}</router-link>-->
                        <p class="title" >{{ li.content }}</p>
                        <!--<p class="date"><span class="icon-date"></span>截止日期：{{ li.endTime && li.endTime.substring(0,10) }}</p>-->
                    </div>
                </div>
                <div class="block">
                    <el-pagination
                            @current-change="(val)=>{handleCurrentChange(val,'pager2')}"
                            :page-size="pager2.pageSize"
                            :current-page="pager2.pageNum"
                            :total="pager2.total"
                            prev-text="上一页"
                            next-text="下一页"
                            layout="total, prev, pager, next"
                            background
                    >
                    </el-pagination>
                </div>

            </el-tab-pane>

             <el-tab-pane :name="'tab03'">
                <span slot="label">客服类</span>
                <div class="todo-list-box">
                    <div class="no-data-tip" v-if="customerToDoList.length == 0"></div>
                    <div v-else class="todo-list" v-for="(li,index) in customerToDoList" :key="index" @click="toCustomerDetail(li)" >
                        <p class="title" >{{ li.content }}</p>
                    </div>
                </div>
                <div class="block">
                    <el-pagination
                            @current-change="(val)=>{handleCurrentChange(val,'pager3')}"
                            :page-size="pager3.pageSize"
                            :current-page="pager3.pageNum"
                            :total="pager3.total"
                            prev-text="上一页"
                            next-text="下一页"
                            layout="total, prev, pager, next"
                            background>
                    </el-pagination>
                </div>
            </el-tab-pane>


        </el-tabs>


    </div><!-- container-center -->
</template>

<script type="text/babel">
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: 'todo-list',
    data () {
        return {
            rules: {

            },
            segmentActive:'',
            todoList: [],
            todoList2: [],
            customerToDoList:[],
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            pager2:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            pager3:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            tabLoading:false,
            confirmDialog: false,
            confirmAccShow: false,
            downloadApi: `${util.baseUrl}rest/file/down`,
            dhsConDisclosure: {
                conName: null,
                content: null,
                status: null,
                conFirDate: null,
                baseFile:null
            }
        }
    },
    methods: {
        tabClick(tab, event){
            this.resetPagination();
            let activeTab = tab.name;
            this.getListByTab(activeTab);
        },

        getListByTab(tab){
             let resultFn = {
                'tab01': this.getSupplierTodoList.bind(this),
                'tab02': ()=>{
                    this.getTodoList({type:'2',pageNum: this.pager2.pageNum,pageSize: this.pager2.pageSize}).then(data =>{
                        this.tabLoading = false;
                        if(data.data.result){
                            this.todoList2 = data.data.value.list || [];
                            this.pager2.total = data.data.value.count || 0;
                        }
                    })
                },
                'tab03': ()=>{
                    this.getTodoList({type:'6',pageNum: this.pager3.pageNum,pageSize: this.pager3.pageSize}).then(data =>{
                         this.tabLoading = false;
                        if(data.data.result){
                            this.customerToDoList = data.data.value.list || [];
                            this.pager3.total = data.data.value.count || 0;
                        }
                    })
                },
            }[tab]
            resultFn ? (resultFn(),this.tabLoading = true) : null;
        },

        getSupplierTodoList () {
            this.$http.post('rest/api/supplierHomepage/getMobileUnDo',{
                pageNum: this.pager.pageNum,
                pageSize: this.pager.pageSize,
                stockId: this.$root.stockId
            }).then((res)=>{
                if(res.data.result) {
                    this.tabLoading = false;
                    this.todoList = res.data.value.list;
                    this.pager.total = res.data.value.totalCount;
                }
            })

        },
        handleCurrentChange (page,key) {
            util.toTop();
            this[key].pageNum = page;
            this.getListByTab(this.segmentActive);
        },

        getTodoList(opt) {
            let baseParams = {
                userId: this.$root.userId,
            }
            return this.$http.post('rest/api/noticeApi/getNoticeList',Object.assign(baseParams,opt))
        },

        resetPagination(){
            this.pager.pageSize = 10;
            this.pager.pageNum = 1;
            this.pager2.pageSize = 10;
            this.pager2.pageNum = 1;
            this.pager3.pageSize = 10;
            this.pager3.pageNum = 1;

        },

        toCustomerDetail(item){
            if(!item.pcUrl) return;
            this.$router.push({name:'CustomerMsgDetail',params:{url:item.pcUrl}})
        },

        handleDialogOpen(id){
            this.getDhsConDisclosureById(id);
            this.confirmDialog = true;
        },
        handleDialogClose(){
            this.confirmDialog = false;
        },
        getDhsConDisclosureById(id){
            this.$http.post('/rest/api/contract/getContractDisclosureInfoByFid', {
                    id:id
                }
            ).then((res)=>{
                if(res.data.result) {
                    this.dhsConDisclosure = res.data.value;
                    if(this.dhsConDisclosure.status==0){
                        this.confirmAccShow=true;
                    }else{
                        this.confirmAccShow=false;
                    }
                }
            } , err => {
                this.$alert(err);
            })
        },
        confirmAcc(id){
            this.$http.post('/rest/api/contract/confirDisclosureInfo', id
            ).then((res)=>{
                if(res.data.result) {
                    this.handleDialogClose();
                    this.getTodoList()
                }
            } , err => {
                this.$alert(err);
            })
        }

    },
    created(){
        this.$root.navs = [{name:'我的待办',path:'/todoList'}];
        this.$root.headImage.src = banner;
        let type = this.$route.params.type || 'invite';
        this.segmentActive = {
            'invite':'tab01',
            'project': 'tab02',
            'customer': 'tab03'
        }[type]
        this.resetPagination();
        this.getListByTab(this.segmentActive)
    },
    mounted () {
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.tabs-margin {margin:20px 0 40px 0;}

.todo-list {width: 100%;border-bottom: 1px solid #E4E5E4;padding:8px 0;}
.todo-list > p {font-size: 14px;margin:0;line-height:28px;}
.todo-list > p.title {width: 1000px;font-weight: bold;}
.todo-list > p.title a {color: #000;text-decoration: none;float:right;}
.todo-list > p.title a:hover {color: var(--cMain);}
.todo-list > p.date {color:#646464;}

span[class^=icon] {display: inline-block;color: #646464;padding-left: 22px;height: 15px;line-height: 28px;background: url("../../../assets/imgs/icon_invite_list_tri.png") no-repeat top left;}
span[class^=icon].icon-date {background: url("../../../assets/imgs/icon_date.png") no-repeat top left;}

.status {float:right;margin-top: 10px;min-width: 80px;padding: 0 5px;color: var(--cMain);border: 1px solid #ced0da;text-align: center;font-size: 12px;line-height: 32px;text-decoration: none;border-radius: 4px;background: -webkit-linear-gradient(#fefeff, #f1f3f7);background: -o-linear-gradient(#fefeff, #f1f3f7);background: -moz-linear-gradient(#fefeff, #f1f3f7);background: linear-gradient(#fefeff, #f1f3f7);}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/home/TodoList.vue